import { render, staticRenderFns } from "./OrgDept.vue?vue&type=template&id=00b5bcd6&scoped=true&"
import script from "./OrgDept.vue?vue&type=script&lang=js&"
export * from "./OrgDept.vue?vue&type=script&lang=js&"
import style0 from "./OrgDept.vue?vue&type=style&index=0&id=00b5bcd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b5bcd6",
  null
  
)

export default component.exports